const labChartData = {
    polyphenols: {
      color: "#dcaa34",
      metrics: {
        polyphenols: {
          label: "Polyphenole",
          title: "Polyphenole",
          copy: "Polyphenole sind natürliche Pflanzenstoffe in Kakao und ein wichtiger Teil des Rohkakao-Profils. Wir weisen sie als EGCG-Äquivalent pro 10 g Kakao aus, damit die Werte mit bekannten polyphenolreichen Lebensmitteln vergleichbar werden.",
          unit: "pro 10 g / 1 Tasse",
          note: "Blaubeeren, Grüntee und Olivenöl dienen als bekannte Referenzen für polyphenolreiche Lebensmittel.",
          rows: [
            ["Tabasqueno", "Mexiko", 524, "524 mg", "moruga"],
            ["Arhuaco", "Kolumbien", 471, "471 mg", "moruga"],
            ["Chuncho", "Peru", 437, "437 mg", "moruga"],
            ["Amazonas", "Peru", 419, "419 mg", "moruga"],
            ["Udzungwa", "Tansania", 332, "332 mg", "moruga"],
            ["Blaubeeren", "Vergleich", 52.5, "52,5 mg", "comparison"],
            ["Grüntee", "Vergleich", 8.9, "8,9 mg", "comparison"],
            ["Olivenöl extra Virgin", "Vergleich", 6.2, "6,2 mg", "comparison"]
          ]
        }
      }
    },
    minerals: {
      color: "#295f53",
      metrics: {
        magnesium: {
          label: "Magnesium",
          title: "Magnesium",
          copy: "Magnesium ist ein Mineralstoff, der im Nährstoffprofil von Kakao regelmäßig mitgemessen wird. In unserem Vergleich liegen Udzungwa und Amazonas beim Magnesium in Kakao fast gleichauf an der Spitze.",
          unit: "pro 10 g / 1 Tasse",
          note: "Mandeln liegen in derselben Größenordnung, Banane deutlich darunter.",
          rows: [
            ["Udzungwa", "Tansania", 28.5, "28,5 mg", "moruga"],
            ["Amazonas", "Peru", 28.4, "28,4 mg", "moruga"],
            ["Chuncho", "Peru", 26.1, "26,1 mg", "moruga"],
            ["Tabasqueno", "Mexiko", 25.7, "25,7 mg", "moruga"],
            ["Arhuaco", "Kolumbien", 25.7, "25,7 mg", "moruga"],
            ["Mandeln", "Vergleich", 26, "26 mg", "comparison"],
            ["Erdnüsse", "Vergleich", 16.8, "16,8 mg", "comparison"],
            ["Banane", "Vergleich", 3, "3 mg", "comparison"]
          ]
        },
        iron: {
          label: "Eisen",
          title: "Eisen",
          copy: "Eisen gehört zu den Mineralstoffen, die das Laborprofil von Kakao greifbarer machen. Wir zeigen den Eisengehalt pro 10 g Kakao und ordnen ihn neben bekannten Lebensmitteln ein.",
          unit: "pro 10 g / 1 Tasse",
          note: "Kürbiskerne sind als Vergleich höher, Spinat und Leber ordnen die Kakao-Werte ein.",
          rows: [
            ["Tabasqueno", "Mexiko", 0.57, "0,57 mg", "moruga"],
            ["Arhuaco", "Kolumbien", 0.57, "0,57 mg", "moruga"],
            ["Udzungwa", "Tansania", 0.38, "0,38 mg", "moruga"],
            ["Chuncho", "Peru", 0.38, "0,38 mg", "moruga"],
            ["Amazonas", "Peru", 0.28, "0,28 mg", "moruga"],
            ["Kürbiskerne", "Vergleich", 1.3, "1,30 mg", "comparison"],
            ["Rindfleisch Leber", "Vergleich", 0.4, "0,40 mg", "comparison"],
            ["Spinat roh", "Vergleich", 0.3, "0,30 mg", "comparison"]
          ]
        },
        zinc: {
          label: "Zink",
          title: "Zink",
          copy: "Zink kommt in Kakao in kleinen, aber messbaren Mengen vor. Die Analyse macht sichtbar, wie sich die Sorten unterscheiden: Amazonas liegt beim Zinkwert vorne, Udzungwa und Arhuaco folgen dicht dahinter.",
          unit: "pro 10 g / 1 Tasse",
          note: "Rindfleisch liegt auf einem ähnlichen Niveau wie mehrere Moruga-Sorten.",
          rows: [
            ["Amazonas", "Peru", 0.44, "0,44 mg", "moruga"],
            ["Udzungwa", "Tansania", 0.41, "0,41 mg", "moruga"],
            ["Arhuaco", "Kolumbien", 0.4, "0,40 mg", "moruga"],
            ["Chuncho", "Peru", 0.38, "0,38 mg", "moruga"],
            ["Tabasqueno", "Mexiko", 0.26, "0,26 mg", "moruga"],
            ["Rindfleisch", "Vergleich", 0.4, "0,40 mg", "comparison"],
            ["Cashews", "Vergleich", 0.3, "0,30 mg", "comparison"],
            ["Spinat roh", "Vergleich", 0.06, "0,06 mg", "comparison"]
          ]
        }
      }
    },
    alkaloids: {
      color: "#0f6b72",
      metrics: {
        theobromine: {
          label: "Theobromin",
          title: "Theobromin",
          copy: "Theobromin ist ein natürliches Alkaloid der Kakaobohne und gehört zu den typischen Inhaltsstoffen von Kakao. Die Messung hilft, die Sorten neben Aroma und Herkunft auch über ihr Alkaloid-Profil zu vergleichen.",
          unit: "pro 10 g / 1 Tasse",
          note: "Grüntee enthält deutlich weniger Theobromin, Filterkaffee praktisch keines.",
          rows: [
            ["Tabasqueno", "Mexiko", 110, "110 mg", "moruga"],
            ["Udzungwa", "Tansania", 94, "94 mg", "moruga"],
            ["Arhuaco", "Kolumbien", 93, "93 mg", "moruga"],
            ["Amazonas", "Peru", 86, "86 mg", "moruga"],
            ["Chuncho", "Peru", 69, "69 mg", "moruga"],
            ["Grüntee", "Vergleich", 30, "30 mg", "comparison"],
            ["Filterkaffee", "Vergleich", 0, "0 mg", "comparison"]
          ]
        },
        caffeine: {
          label: "Koffein",
          title: "Koffein",
          copy: "Koffein kommt in Kakao natürlicherweise vor, meist deutlich niedriger als in Kaffee. Wir zeigen den Koffeingehalt pro 10 g Kakao, damit du die Größenordnung zwischen den Sorten und gegenüber Kaffee besser einordnen kannst.",
          unit: "pro 10 g / 1 Tasse",
          note: "Die Kaffee- und Tee-Referenzen bleiben in derselben Grafik, damit das Verhältnis sofort erkennbar ist.",
          rows: [
            ["Chuncho", "Peru", 29, "29 mg", "moruga"],
            ["Amazonas", "Peru", 19, "19 mg", "moruga"],
            ["Udzungwa", "Tansania", 13, "13 mg", "moruga"],
            ["Arhuaco", "Kolumbien", 12, "12 mg", "moruga"],
            ["Tabasqueno", "Mexiko", 11, "11 mg", "moruga"],
            ["Filterkaffee", "Vergleich", 190, "190 mg", "comparison"],
            ["Espresso single", "Vergleich", 64, "64 mg", "comparison"],
            ["Schwarztee", "Vergleich", 44, "44 mg", "comparison"]
          ]
        }
      }
    },
    heavy: {
      color: "#8f3f43",
      metrics: {
        cadmium: {
          label: "Cadmium",
          title: "Cadmium",
          copy: "Cadmium kann in Kakao als natürlicher Begleitstoff aus dem Boden vorkommen und wird deshalb besonders sorgfältig geprüft. Wir zeigen die Cadmiumwerte pro kg und ordnen sie transparent gegen den EU-Höchstwert ein.",
          unit: "pro 1 kg",
          note: "Der EU-Höchstwert ist als wichtigste Orientierung direkt in der Grafik aufgeführt.",
          rows: [
            ["Amazonas", "Peru", 0.48, "0,48 mg", "moruga"],
            ["Tabasqueno", "Mexiko", 0.41, "0,41 mg", "moruga"],
            ["Arhuaco", "Kolumbien", 0.13, "0,13 mg", "moruga"],
            ["Chuncho", "Peru", 0.12, "0,12 mg", "moruga"],
            ["Udzungwa", "Tansania", 0.11, "0,11 mg", "moruga"],
            ["EU-Höchstwert", "Grenzwert", 0.8, "0,80 mg", "comparison"],
            ["Sonnenblumenkerne", "Vergleich", 0.1, "0,10 mg", "comparison"],
            ["Spinat roh", "Vergleich", 0.06, "0,06 mg", "comparison"],
            ["Nudeln trocken", "Vergleich", 0.04, "0,04 mg", "comparison"]
          ]
        },
        lead: {
          label: "Blei",
          title: "Blei",
          copy: "Blei gehört zu den Schwermetallen, die wir in jeder getesteten Kakaosorte mit prüfen lassen. In den aktuellen Moruga-Analysen liegt Blei bei allen Sorten unter der Nachweisgrenze.",
          unit: "pro 1 kg",
          note: "Die Werte liegen unterhalb der Nachweisgrenze. Der EU-Höchstwert zeigt die zusätzliche Einordnung.",
          rows: [
            ["Tabasqueno", "Mexiko", 0.005, "<0,005 mg", "moruga"],
            ["Arhuaco", "Kolumbien", 0.005, "<0,005 mg", "moruga"],
            ["Udzungwa", "Tansania", 0.005, "<0,005 mg", "moruga"],
            ["Chuncho", "Peru", 0.005, "<0,005 mg", "moruga"],
            ["Amazonas", "Peru", 0.005, "<0,005 mg", "moruga"],
            ["EU-Höchstwert", "Grenzwert", 0.1, "0,10 mg", "comparison"]
          ]
        }
      }
    }
  };

  const heavySafetyData = {
    cadmium: {
      color: "#dcaa34",
      kicker: "EU-Höchstwert für Cadmium in dieser Einordnung",
      value: "0,80",
      note: "mg pro kg. Der höchste gemessene Moruga-Wert liegt bei 0,48 mg/kg.",
      aria: "Cadmiumwerte im Vergleich zum EU-Grenzwert",
      rows: [
        ["Amazonas", 60, "0,48 mg/kg"],
        ["Tabasqueno", 51.25, "0,41 mg/kg"],
        ["Arhuaco", 16.25, "0,13 mg/kg"],
        ["Chuncho", 15, "0,12 mg/kg"],
        ["Udzungwa", 13.75, "0,11 mg/kg"],
        ["EU-Höchstwert", 100, "0,80 mg/kg"]
      ]
    },
    lead: {
      color: "#d7b66a",
      kicker: "Blei in allen getesteten Moruga-Sorten",
      value: "<0,005",
      note: "mg pro kg. Blei liegt in allen getesteten Sorten unter der Nachweisgrenze.",
      aria: "Bleiwerte im Vergleich zur Nachweisgrenze und zum EU-Höchstwert",
      rows: [
        ["Tabasqueno", 5, "<0,005 mg/kg"],
        ["Arhuaco", 5, "<0,005 mg/kg"],
        ["Udzungwa", 5, "<0,005 mg/kg"],
        ["Chuncho", 5, "<0,005 mg/kg"],
        ["Amazonas", 5, "<0,005 mg/kg"],
        ["EU-Höchstwert", 100, "0,10 mg/kg"]
      ]
    }
  };

  document.querySelectorAll(".moruga-lab-page").forEach((root) => {
    const tabs = root.querySelectorAll(".moruga-lab-tabs button");
    const metricSwitcher = root.querySelector("[data-lab-metric-switcher]");
    const title = root.querySelector("[data-lab-chart-title]");
    const copy = root.querySelector("[data-lab-chart-copy]");
    const unit = root.querySelector("[data-lab-chart-unit]");
    const list = root.querySelector("[data-lab-chart-list]");
    const noteText = root.querySelector("[data-lab-chart-note]");
    const morugaLegend = root.querySelector("[data-lab-moruga-legend]");
    const selectedMetricByGroup = {
      polyphenols: "polyphenols",
      minerals: "magnesium",
      alkaloids: "theobromine",
      heavy: "cadmium"
    };

    function renderMetricControls(group) {
      const metrics = labChartData[group].metrics;
      metricSwitcher.innerHTML = Object.entries(metrics).map(([key, metric]) => (
        `<button type="button" data-metric="${key}" aria-selected="${selectedMetricByGroup[group] === key}">${metric.label}</button>`
      )).join("");
      metricSwitcher.querySelectorAll("button").forEach((chip) => {
        chip.addEventListener("click", () => {
          selectedMetricByGroup[group] = chip.dataset.metric;
          renderChart(group);
        });
      });
    }

    function renderChart(group) {
      const data = labChartData[group];
      const metricKey = selectedMetricByGroup[group] || Object.keys(data.metrics)[0];
      const metric = data.metrics[metricKey];
      const max = Math.max(...metric.rows.map((row) => row[2])) || 1;
      root.dataset.activeGroup = group;
      title.textContent = metric.title;
      copy.textContent = metric.copy;
      unit.textContent = metric.unit;
      noteText.textContent = metric.note;
      morugaLegend.style.setProperty("--legend-color", data.color);
      list.innerHTML = metric.rows.map(([name, origin, value, label, type]) => {
        const width = Math.max(4, (value / max) * 100);
        const rowClass = type === "comparison" ? "moruga-lab-bar is-comparison" : "moruga-lab-bar";
        const tone = type === "comparison" ? "#c7653b" : data.color;
        return `
          <div class="${rowClass}">
            <div class="moruga-lab-bar-label">${name}<span>${origin}</span></div>
            <div class="moruga-lab-track"><div class="moruga-lab-fill" style="--value: ${width}%; --bar-color: ${tone};"></div></div>
            <div class="moruga-lab-bar-value">${label}</div>
          </div>
        `;
      }).join("");
      renderMetricControls(group);
      tabs.forEach((tab) => tab.setAttribute("aria-selected", String(tab.dataset.group === group)));
    }

    tabs.forEach((tab) => {
      tab.addEventListener("click", () => renderChart(tab.dataset.group));
    });

    renderChart("polyphenols");

    const heavySafety = root.querySelector("[data-heavy-safety]");
    if (heavySafety) {
      const heavyButtons = heavySafety.querySelectorAll("[data-heavy-metric]");
      const heavyKicker = heavySafety.querySelector("[data-heavy-kicker]");
      const heavyValue = heavySafety.querySelector("[data-heavy-value]");
      const heavyNote = heavySafety.querySelector("[data-heavy-note]");
      const heavyList = heavySafety.querySelector("[data-heavy-list]");

      function renderHeavySafety(metricKey) {
        const metric = heavySafetyData[metricKey] || heavySafetyData.cadmium;
        heavyKicker.textContent = metric.kicker;
        heavyValue.textContent = metric.value;
        heavyNote.textContent = metric.note;
        heavyList.setAttribute("aria-label", metric.aria);
        heavyList.style.setProperty("--heavy-color", metric.color);
        heavyList.innerHTML = metric.rows.map(([name, width, label]) => `
          <div><b>${name}</b><span><i style="--limit: ${width}%;"></i></span><em>${label}</em></div>
        `).join("");
        heavyButtons.forEach((button) => {
          button.setAttribute("aria-selected", String(button.dataset.heavyMetric === metricKey));
        });
      }

      heavyButtons.forEach((button) => {
        button.addEventListener("click", () => renderHeavySafety(button.dataset.heavyMetric));
      });
      renderHeavySafety("cadmium");
    }
  });
